export default "__VITE_ASSET__CWvr9N7y__"